import { emailRegex } from "../lib/Variable";

const loginValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  return hasError;
};

const registerAgentValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (!obj.username) {
    setInputError((prev) => ({ ...prev, username: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }
  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }
  if (!obj.dailyTarget) {
    setInputError((prev) => ({ ...prev, dailyTarget: true }));
    hasError = true;
  }
  if (!obj.sellsTarget) {
    setInputError((prev) => ({ ...prev, sellsTarget: true }));
    hasError = true;
  }
  if (!obj.colorCode) {
    setInputError((prev) => ({ ...prev, colorCode: true }));
    hasError = true;
  }
  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }
  if (!obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, confirmPassword: true }));
    hasError = true;
  }
  if (obj.password !== obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, isPasswordMatch: true }));
    hasError = true;
  }

  return hasError;
};

const generalInfoValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (!obj.username) {
    setInputError((prev) => ({ ...prev, username: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }
  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }
  if (!obj.dailyTarget) {
    setInputError((prev) => ({ ...prev, dailyTarget: true }));
    hasError = true;
  }
  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }
  if (!obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, confirmPassword: true }));
    hasError = true;
  }
  if (obj.password !== obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, isPasswordMatch: true }));
    hasError = true;
  }

  return hasError;
};

const createLeadProposalValidation = (
  obj,
  setInputError,
  enableThirdParty,
  allProducts
) => {
  let hasError = false;

  if (!obj.productType) {
    setInputError((prev) => ({ ...prev, productType: true }));
    hasError = true;
  }

  if (!obj.username) {
    setInputError((prev) => ({ ...prev, username: true }));
    hasError = true;
  }

  if (!obj.businessName) {
    setInputError((prev) => ({ ...prev, businessName: true }));
    hasError = true;
  }

  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }

  // Check if selected product is CPS - if not CPS, then followUpDate is required
  const selectedProduct = allProducts?.find(
    (product) => product._id === obj.productType
  );
  if (selectedProduct && selectedProduct.name !== "CPS" && !obj.followUpDate) {
    setInputError((prev) => ({ ...prev, followUpDate: true }));
    hasError = true;
  }

  if (enableThirdParty && !obj.receiverEmail) {
    setInputError((prev) => ({ ...prev, receiverEmail: true }));
    hasError = true;
  }

  if (obj.receiverEmail && !emailRegex.test(obj.receiverEmail)) {
    setInputError((prev) => ({ ...prev, isValidReceiverEmail: true }));
    hasError = true;
  }

  // if (!obj.contact) {
  //   setInputError((prev) => ({ ...prev, contact: true }));
  //   hasError = true;
  // }

  // if (!obj.address) {
  //   setInputError((prev) => ({ ...prev, address: true }));
  //   hasError = true;
  // }

  // if (!obj.email) {
  //   setInputError((prev) => ({ ...prev, email: true }));
  //   hasError = true;
  // }

  // if (!obj.contractEndDate) {
  //   setInputError((prev) => ({ ...prev, contractEndDate: true }));
  //   hasError = true;
  // }

  // if (!obj.currentProvider) {
  //   setInputError((prev) => ({ ...prev, currentProvider: true }));
  //   hasError = true;
  // }
  // if (!obj.note) {
  //   setInputError((prev) => ({ ...prev, note: true }));
  //   hasError = true;
  // }

  return hasError;
};

const addTarrifValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.value) {
    setInputError((prev) => ({ ...prev, value: true }));
    hasError = true;
  }
  if (!obj.description) {
    setInputError((prev) => ({ ...prev, description: true }));
    hasError = true;
  }
  if (!obj.buyPrice || obj.buyPrice <= 0) {
    setInputError((prev) => ({ ...prev, buyPrice: true }));
    hasError = true;
  }
  if (!obj.salePrice || obj.salePrice <= 0) {
    setInputError((prev) => ({ ...prev, salePrice: true }));
    hasError = true;
  }
  if (!obj.highPrice || obj.highPrice <= 0) {
    setInputError((prev) => ({ ...prev, highPrice: true }));
    hasError = true;
  }
  if (!obj.length12 || obj.length12 <= 0) {
    setInputError((prev) => ({ ...prev, length12: true }));
    hasError = true;
  }
  if (!obj.length18 || obj.length18 <= 0) {
    setInputError((prev) => ({ ...prev, length18: true }));
    hasError = true;
  }
  if (!obj.length24 || obj.length24 <= 0) {
    setInputError((prev) => ({ ...prev, length24: true }));
    hasError = true;
  }
  if (!obj.length36 || obj.length36 <= 0) {
    setInputError((prev) => ({ ...prev, length36: true }));
    hasError = true;
  }

  return hasError;
};

const addEquipmentValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }

  if (!obj.oneOffCostPrice || obj.oneOffCostPrice <= 0) {
    setInputError((prev) => ({ ...prev, oneOffCostPrice: true }));
    hasError = true;
  }

  if (!obj.monthlyPrice || obj.monthlyPrice <= 0) {
    setInputError((prev) => ({ ...prev, monthlyPrice: true }));
    hasError = true;
  }

  return hasError;
};

const registerAdminValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (!obj.username) {
    setInputError((prev) => ({ ...prev, username: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }
  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }
  if (!obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, confirmPassword: true }));
    hasError = true;
  }
  if (obj.password !== obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, isPasswordMatch: true }));
    hasError = true;
  }

  return hasError;
};

const addEditDiscountValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }

  if (!obj.percentage) {
    setInputError((prev) => ({ ...prev, percentage: true }));
    hasError = true;
  }

  if (obj.month === "") {
    setInputError((prev) => ({ ...prev, month: true }));
    hasError = true;
  }

  if (!obj.length || obj.length.length === 0) {
    setInputError((prev) => ({ ...prev, length: true }));
    hasError = true;
  }
  if (!obj.minimumPrice || obj.minimumPrice <= 0) {
    setInputError((prev) => ({ ...prev, minimumPrice: true }));
    hasError = true;
  }

  return hasError;
};

const serviceAgrementValidation = (
  inputValues,
  setInputError,
  formErrorRef
) => {
  const errors = {};

  if (!inputValues.businessName?.trim()) {
    errors.businessName = "Business name/Merchant name is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#business-name");
    }
  } else if (inputValues.businessName?.trim().length < 3) {
    errors.businessName =
      "Business name/Merchant name must be at least 3 characters long";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#business-name");
    }
  }

  if (inputValues.tradingName && inputValues.tradingName?.trim().length < 3) {
    errors.tradingName = "Trading name must be at least 3 characters long";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#trading-name");
    }
  }

  if (!inputValues.businessPhone?.trim()) {
    errors.businessPhone = "Business phone is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#business-phone");
    }
  }

  if (
    inputValues.businessUrl &&
    !/^https?:\/\/.+$/.test(inputValues.businessUrl)
  ) {
    errors.businessUrl = "Business URL must be a valid URL";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#business-url");
    }
  }

  if (!inputValues.email?.trim()) {
    errors.email = "Email is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#email");
    }
  } else if (!emailRegex.test(inputValues.email)) {
    errors.email = "Email must be a valid email address";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#email");
    }
  }

  if (!inputValues.yearsInBusiness || inputValues.yearsInBusiness <= 0) {
    errors.yearsInBusiness = "Years in business is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#years-in-business");
    }
  }

  if (
    inputValues.registrationNo?.trim() &&
    inputValues.registrationNo?.trim().length < 3
  ) {
    errors.registrationNo =
      "Registration number must be at least 3 characters long";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#registration-no");
    }
  }

  // if (!inputValues.manufacturer?.trim()) {
  //   errors.manufacturer = "Manufacturer is required";
  //   if (!formErrorRef.current) {
  //     formErrorRef.current = document.querySelector("#manufacturer");
  //   }
  // }

  if (!inputValues.equipmentModel?.trim()) {
    errors.equipmentModel = "Equipment model is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#equipment-model");
    }
  }

  if (!inputValues.quantity || inputValues.quantity <= 0) {
    errors.quantity = "Quantity is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#quantity");
    }
  }

  if (inputValues.onSitePayment == null || inputValues.onSitePayment === "") {
    errors.onSitePayment = "On site payment cannot be empty";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector(
        "#installation-payment-onsite"
      );
    }
  } else if (Number(inputValues.onSitePayment) < 0) {
    errors.onSitePayment = "On site payment cannot be less than 0";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector(
        "#installation-payment-onsite"
      );
    }
  }

  if (inputValues.monthlyPayment == null || inputValues.monthlyPayment === "") {
    errors.monthlyPayment = "Monthly payment cannot be empty";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector(
        "#installation-payment-monthly"
      );
    }
  } else if (Number(inputValues.monthlyPayment) < 0) {
    errors.monthlyPayment = "Monthly payment cannot be less than 0";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector(
        "#installation-payment-monthly"
      );
    }
  }

  if (!inputValues.addressLine1?.trim()) {
    errors.addressLine1 = "Address line 1 is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#address-line-1");
    }
  } else if (inputValues.addressLine1?.trim().length < 3) {
    errors.addressLine1 = "Address line 1 must be at least 3 characters long";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#address-line-1");
    }
  }

  if (!inputValues.town?.trim()) {
    errors.town = "Town is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#town");
    }
  }

  if (!inputValues.county?.trim()) {
    errors.county = "County is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#county");
    }
  }

  if (!inputValues.postcode?.trim()) {
    errors.postcode = "Postcode is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#postcode");
    }
  }

  if (!inputValues.country?.trim()) {
    errors.country = "Country is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#country");
    }
  }

  if (!inputValues.contactName?.trim()) {
    errors.contactName = "Contact name is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#contact-name");
    }
  } else if (inputValues.contactName?.trim().length < 3) {
    errors.contactName = "Contact name must be at least 3 characters long";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#contact-name");
    }
  }

  if (!inputValues.position?.trim()) {
    errors.position = "Position is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#position");
    }
  }

  if (!inputValues.contactPhone?.trim()) {
    errors.contactPhone = "Contact phone is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#contact-phone");
    }
  }

  if (!inputValues.installationAddress?.trim()) {
    errors.installationAddress = "Installation address is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#installation-address");
    }
  } else if (inputValues.installationAddress?.trim().length < 3) {
    errors.installationAddress =
      "Installation address must be at least 3 characters long";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#installation-address");
    }
  }

  if (!inputValues.minTerm) {
    errors.minTerm = "Minimum term is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#min-term");
    }
  }

  if (!inputValues.nameOnAccount?.trim()) {
    errors.nameOnAccount = "Name on account is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#name-on-account");
    }
  }

  if (!inputValues.bankName?.trim()) {
    errors.bankName = "Bank name is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#bank-name");
    }
  }

  if (!inputValues.bankAccountNumber?.trim()) {
    errors.bankAccountNumber = "Bank account number is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#bank-account-number");
    }
  } else if (inputValues.bankAccountNumber.trim().length !== 8) {
    errors.bankAccountNumber = "Bank account number must be exactly 8 digits";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#bank-account-number");
    }
  }

  if (!inputValues.bankSortCode?.trim()) {
    errors.bankSortCode = "Bank sort code is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#bank-sort-code");
    }
  } else if (inputValues.bankSortCode.trim().length !== 6) {
    errors.bankSortCode = "Bank sort code must be exactly 6 digits";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#bank-sort-code");
    }
  }

  if (!inputValues.bankPostCode?.trim()) {
    errors.bankPostCode = "Bank post code is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#bank-post-code");
    }
  }

  if (!inputValues.bankAddress?.trim()) {
    errors.bankAddress = "Bank address is required";
    if (!formErrorRef.current) {
      formErrorRef.current = document.querySelector("#bank-address");
    }
  }

  setInputError(errors);
  return Object.keys(errors).length === 0;
};

export {
  loginValidation,
  registerAgentValidation,
  generalInfoValidation,
  createLeadProposalValidation,
  addTarrifValidation,
  addEquipmentValidation,
  registerAdminValidation,
  addEditDiscountValidation,
  serviceAgrementValidation,
};
